exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



// WEBPACK FOOTER //
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/builds/new-media/admin.lajt-online.pl/platform/src/theme/styles/mixins.sass","/builds/new-media/admin.lajt-online.pl/platform/src/theme/styles/defs/colors.sass"]}!./src/rcapp/components/layout/removeButton/style.sass